<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> 申请提现
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <el-form :data="tableData">
                <el-form-item label="财务公司：" label-width="120px">
                    {{tableData.company_name}}
                </el-form-item>
                 <el-form-item label="已提现金额：" label-width="120px">
                    <el-button type="text" @click="look()">{{tableData.y_money}}</el-button>
                </el-form-item>
                 <el-form-item label="可提现金额：" label-width="120px">
                    {{tableData.k_money}}
                </el-form-item>
               
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="withdrawal=true" style="margin-left:30px">提现</el-button>
            </span>
        </div>
         <el-dialog title="申请提现" :visible.sync="withdrawal" width="500px">
            <el-form ref="editForm" :rules="rules" :model="editForm" label-width="140px" >
                <el-form-item label="提现方式" prop="mode">
                    <el-select v-model="editForm.mode" placeholder="请输入" class="handle-input mr10" @change="modechange">
                        <el-option v-for="item in modeList" 
                        :label="item.label"
                        :key="item.label"
                        :value="item.label">
                        </el-option>
                    </el-select>   
                </el-form-item>
                <el-form-item label="姓名" prop="name">
                    <el-input v-model="editForm.name"></el-input>
                </el-form-item>
                <el-form-item label="收款账号" prop="account">
                    <el-input v-model.number="editForm.account"></el-input>
                </el-form-item>
                <el-form-item label="银行卡转账开户行" prop="opening" v-if="modeVisiable">
                    <el-input v-model="editForm.opening"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="withdrawal = false">取 消</el-button>
                <el-button type="primary" @click="withdrawalfunction()">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="提现明细" :visible.sync="lookVisiable" width="1500px">
            <div class="handle-box" style="width:1500px">
                <el-form :model="query" ref="query" label-width="80px" inline="">
                    <el-form-item label="收款账号:" label-width="75px" prop="account">
                        <el-input v-model="query.account" placeholder="请输入" class="handle-input mr10" @input="inputSearch()"></el-input>
                    </el-form-item>
                    <el-form-item label="收款人:" label-width="75px" prop="name">
                        <el-input v-model="query.name" placeholder="请输入" class="handle-input mr10" @input="inputSearch()"></el-input>
                    </el-form-item>
                    <el-form-item label="提现方式:" label-width="75px" prop="mode">
                        <el-select v-model="query.mode" placeholder="请输入" class="handle-input mr10" @change="inputSearch()">
                             <el-option v-for="item in modeList"
                                :key="item.label"
                                :label="item.label"
                                :value="item.label">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="申请时间" >
                        <el-date-picker class="data" type="date" placeholder="起始日期" v-model="query.start_time" style="width: 150px;padding-right:5px"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd" @change="inputSearch()"></el-date-picker>
                        <span>-</span>
                        <el-date-picker  format="yyyy-MM-dd" value-format="yyyy-MM-dd" class="data" type="date" placeholder="结束日期" v-model="query.end_time" style="width: 150px;padding-right:10px;padding-left:5px" @change="inputSearch()">
                        </el-date-picker>
                   </el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="getmingxi()">搜索</el-button>
                    <el-button type="primary"  @click="resetsearch()">重置</el-button>
                </el-form>
            </div>
            <el-table
                :data="mingxi"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
            >
                <el-table-column prop="id" label="ID" width="55" align="center"  fixed="left"></el-table-column>
                <el-table-column prop="name" label="用户昵称"  align="center"></el-table-column>
                <el-table-column prop="mode" label="提现方式" width="150" align="center"></el-table-column>
                <el-table-column prop="account" label="收款账号"  width="200" align="center"></el-table-column>
                <el-table-column prop="opening" label="开户银行" width="150" align="center"></el-table-column>
                <el-table-column prop="amount" label="提现金额"  align="center"></el-table-column>
                <el-table-column prop="can_withdraw" label="可到账金额"  align="center"></el-table-column>
                <el-table-column prop="status" label="状态"  align="center">
                    <template slot-scope="scope">
                       <span v-if="scope.row.status==1" style="color:rgb(22,162,251)">待审核</span>
                       <span v-else-if="scope.row.status==2" style="color:rgb(236, 160,70)">待打款</span>
                       <span v-else-if="scope.row.status==3" style="color:rgb(22,162,51)">提现成功</span>
                       <span v-else style="color:rgb(242, 94, 67)">提现失败</span>
                    </template>
                </el-table-column>
                <el-table-column prop="start_time" label="申请时间" width="180" align="center"></el-table-column>
                <el-table-column prop="end_time" label="到账时间"  width="180" align="center"></el-table-column>
                
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </el-dialog>
    </div>
</template>

<script>


import { post } from '../../../api/request';

export default {
    name: 'basetable',
    data() {
        return {
            mingxi:[],
            lookVisiable:false,
            pageTotal: 0,      
            query: {
                account:'',
                mode:'',
                name:'',
                start_time:'',
                end_time:'',
                status:'',
                pageIndex: 1,
                pageSize: 8,
                cpyid:""
            },
            modeList:[{
                label:"微信零钱"
            },{
                label:"微信线下打款"
            },{
                label:"支付宝线下打款"
            },{
                label:"银联线下打款"
            }],
            modeVisiable:false,
            editForm:{
                mode:'',
                name:'',
                account:'',
                opening:''
            },
            withdrawal:false,
            id:"",
            companyid:'',//当前公司id
            //搜索数据
            tableData: {},
            form:{},
            rules: {
                mode: [{ required: true, message: '请选择提现方式', trigger: 'blur' }],
                name: [{ required: true, message: '请输入收款人姓名', trigger: 'blur' }],
                account: [{ required: true, message: '请输入收款人账号', trigger: 'blur' },
                  { type: 'number', message: '账号必须为数字值'}],
                opening: [{ required: true, message: '请输入收款人开户行', trigger: 'blur' }],
            },
        };
    },
    created() {
        this.companyid =  sessionStorage.getItem('companyid')
        this.id =  sessionStorage.getItem('userid')
        this.getData()
    },
    activated() {
        this.companyid =  sessionStorage.getItem('companyid')
        this.id =  sessionStorage.getItem('userid')
        this.getData()
    },
    methods: {
        look(){
            this.getmingxi()
            this.lookVisiable = true
            
        },
        getmingxi(){
            let formdata = new FormData()
            formdata.append('company_id',this.companyid)
            formdata.append('page',this.query.pageIndex)
            formdata.append('limit',this.query.pageSize)
            formdata.append('mode',this.query.mode)
            formdata.append('account',this.query.account)
            formdata.append('name',this.query.name)
            formdata.append('start_time',this.query.start_time)
            formdata.append('end_time',this.query.end_time)
            formdata.append('status',3)
            formdata.append('cpy_id',this.id)
            post("admin/Order/selecpycom",formdata).then(res=>{
                this.mingxi = res.data.data.list
                this.pageTotal = res.data.data.num
            })
        },
        modechange(val){
            if(val=="银联线下打款")
                this.modeVisiable = true
            else
                this.modeVisiable = false
        },
        resetsearch(){
             this.$refs['query'].resetFields()
            this.query.start_time=""
            this.query.end_time=""
            this.query.pageIndex = 1
            this.getmingxi()
        },
         inputSearch(){
            let formdata = new FormData()
            formdata.append('company_id',this.companyid)
            formdata.append('page',1)
            formdata.append('limit',this.query.pageSize)
            formdata.append('mode',this.query.mode)
            formdata.append('account',this.query.account)
            formdata.append('name',this.query.name)
            formdata.append('start_time',this.query.start_time)
            formdata.append('end_time',this.query.end_time)
            formdata.append('status',3)
            formdata.append('cpy_id',this.id)
            post("admin/Order/selecpycom",formdata).then(res=>{
                this.mingxi = res.data.data.list
                this.pageTotal = res.data.data.num
            })
        },
        //重置表单
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        // 获取后端接口数据
        getData() {
            let formdata = new FormData()
            formdata.append('id',this.id)
            post('admin/order/selcpy',formdata).then(res => {
                if(res.code=200){
                    this.tableData = res.data.data[0];
                }
                else{
                    this.$message.error("暂无数据")
                }
            });
        },
        withdrawalfunction(){
            this.$refs['editForm'].validate((valid) => {
                if (valid) {
                    let formdata = new FormData()
                    formdata.append('company_id',this.companyid)
                    formdata.append('cpy_id',this.id)
                    formdata.append('mode',this.editForm.mode)
                    formdata.append('name',this.editForm.name)
                    formdata.append('account',this.editForm.account)
                    formdata.append('opening',this.editForm.opening)   
                    post("admin/order/cpydraw",formdata).then(res=>{
                        this.$refs['addForm'].resetFields();
                        this.getData()
                    })
                }
            })
        },
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>

.next-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.editor-btn{
    margin-top: 20px;
}

</style>
